import styles from './SignUp.module.css'
import SignUpForm from '../../components/SignUp/SignUpForm'
import { Link } from 'react-router-dom'
import AuthBase from '../../common/components/Auth/AuthBase'
import { t } from 'i18next'

const SignUpPage = () => (
  <AuthBase hasBackButton>
    <div className={styles.container}>
      <p className={styles.formLabel}>{t('login.signUp')}</p>
      <SignUpForm />
      <div className={styles.haveAccountSign}>
        <p>{t('signup.alreadyHaveAccount')}</p>
        <Link to="/">
          <p className={styles.login}>{t('login.logIn')}</p>
        </Link>
      </div>
    </div>
  </AuthBase>
)

export default SignUpPage
